// Section nhân vật (MU Lục Địa) — 2 Swiper đồng bộ: thẻ bài (thumbs) điều khiển nội dung chính

window.addEventListener("load", function () {
    var main = document.querySelector('#characters .character-main');
    var cardsEl = document.querySelector('#characters .character-cards');
    if (!main || !cardsEl || typeof Swiper === 'undefined') return;

    // Swiper thẻ bài (thumbs) — loop để chạy vòng tròn, active luôn kéo về đầu.
    var cards = new Swiper(cardsEl, {
        loop: true,
        slidesPerView: 3,
        spaceBetween: 15,
        centeredSlides: false,
        watchSlidesProgress: true,
        slideToClickedSlide: false,
    });

    // Swiper nội dung chính: LOOP + fade. main loop để 7->0 đi tiếp (phải->trái),
    // không bị trượt lùi cả dải. Đồng bộ qua module thumbs.
    var mainSwiper = new Swiper(main, {
        loop: true,
        effect: 'fade',
        fadeEffect: { crossFade: true },
        speed: 600,
        thumbs: { swiper: cards },
        pagination: {
            el: '#characters .swiper-pagination',
            clickable: true,
        },
        navigation: {
            prevEl: '#characters .char-prev',
            nextEl: '#characters .char-next',
        },
    });

    // Đổi ảnh nền (PC + mobile) theo nhân vật đang active.
    // Path lấy trực tiếp từ <template class="bg-srcs"> trong twig (loop theo
    // characters) — build-pro đã rewrite src sang optimized/*.webp, JS chỉ đọc &
    // gán nên không cần hardcode mảng literal, dễ maintain khi thêm/bớt nhân vật.
    var tpl = document.querySelector('#characters .background .bg-srcs');
    var BG_PC = [], BG_MB = [];
    if (tpl && tpl.content) {
        tpl.content.querySelectorAll('img.bg-pc').forEach(function (im) {
            BG_PC.push(im.getAttribute('src'));
        });
        tpl.content.querySelectorAll('img.bg-mb').forEach(function (im) {
            BG_MB.push(im.getAttribute('src'));
        });
    }
    var bgPc = document.querySelector('#characters .background .js-bg-pc');
    var bgMb = document.querySelector('#characters .background .js-bg-mb');
    function setBg(i) {
        if (bgPc && BG_PC[i]) bgPc.src = BG_PC[i];
        if (bgMb && BG_MB[i]) bgMb.src = BG_MB[i];
    }

    // Luôn kéo thẻ active về vị trí đầu tiên. cards loop -> dùng slideToLoop
    // (theo realIndex) để luôn có 2 thẻ phía sau, kể cả thẻ cuối.
    mainSwiper.on('slideChange', function () {
        cards.update();
        cards.slideToLoop(mainSwiper.realIndex);
        setBg(mainSwiper.realIndex);
    });
    cards.update();
    cards.slideToLoop(0, 0);
    setBg(mainSwiper.realIndex);

    // Cập nhật lại sau khi layout/ảnh ổn định để tránh lệch vị trí thẻ lúc khởi tạo
    setTimeout(function () {
        cards.update();
        mainSwiper.update();
        cards.slideToLoop(mainSwiper.realIndex, 0);
    }, 300);
});
